module.exports = require("@swa-ui/core/src/ToggleButtonGroup/ToggleButton.module.scss");